<template>
  <!-- Center -->
  <TelemetreLaser_affichage :config="config" v-if="config.openTelemetreLaser" />
  <Drag :config="config" v-if="config.camera.payloadAsSelected" />

  <!-- LEFT -->
  <div
    class="absolute h-full top-[0px] left-[2px] z-10 flex flex-col items-center justify-center"
  >
    <TelemetreLaser_btn :config="config" />
    <!-- Camera|Photo Mode -->
    <Mode_Switch
      :config="config"
      :video="video"
      v-if="config.camera.payloadAsSelected"
    />
    <!-- Lens -->
    <Lens :config="config" :video="video" />
    <!-- Resolution -->
    <Resolution :config="config" :video="video" />
  </div>
  <!-- END LEFT -->

  <!-- RIGHT -->
  <div
    class="absolute h-full top-[0px] right-[2px] z-10 flex justify-center items-center"
  >
    <Mode_Remain :config="config" :video="video" />
    <Mode_Photo
      :config="config"
      :video="video"
      v-if="config.camera.payloadAsSelected"
    />
    <Mode_Camera
      :config="config"
      :video="video"
      v-if="config.camera.payloadAsSelected"
    />
    <Zoom :config="config" :video="video" />
  </div>
  <!-- END RIGHT -->

  <!-- Down -->
  <!-- <div class="absolute bottom-[2px] left-[2px] z-10 flex flex-col items-center">

  </div> -->
</template>

<script>
import { ref } from "vue";

import Lens from "@/partials/Video/Camera/Options/Lens.vue";
import Resolution from "@/partials/Video/Camera/Options/Resolution.vue";
import Zoom from "@/partials/Video/Camera/Options/Zoom.vue";

import Mode_Switch from "@/partials/Video/Camera/Options/Mode/Mode_Switch.vue";
import Mode_Camera from "@/partials/Video/Camera/Options/Mode/Mode_Camera.vue";
import Mode_Photo from "@/partials/Video/Camera/Options/Mode/Mode_Photo.vue";
import Mode_Remain from "@/partials/Video/Camera/Options/Mode/Mode_Remain.vue";

// import Drag from "@/partials/Video/Camera/Options/Drag.vue";
import Drag from "@/partials/Video/Camera/Options/DragDblClick.vue";

import TelemetreLaser_btn from "@/partials/Video/Camera/Options/TelemetreLaser/TelemetreLaser_btn.vue";
import TelemetreLaser_affichage from "@/partials/Video/Camera/Options/TelemetreLaser/TelemetreLaser_affichage.vue";

export default {
  name: "Camera",
  props: {
    config: Object,
    video: Object,
  },
  components: {
    Mode_Switch,
    Mode_Camera,
    Mode_Photo,
    Mode_Remain,

    Lens,
    Resolution,
    Zoom,

    Drag,

    TelemetreLaser_btn,
    TelemetreLaser_affichage,
  },
  setup() {},

  mounted() {},

  methods: {},
};
</script>
